(() => {
  const KEY = 'stonehaus:saved-stones:v1';
  const SAMPLE_VARIANT_ID = 49458844565742;
  const $all = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]').filter(item => item && item.handle); }
    catch (_) { return []; }
  };
  const write = items => {
    try { localStorage.setItem(KEY, JSON.stringify(items)); }
    catch (_) {}
    document.dispatchEvent(new CustomEvent('stonehaus:saved-stones:change'));
  };
  const esc = value => String(value || '').replace(/[&<>'"]/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  const productFromButton = button => ({
    id: button.dataset.id,
    handle: button.dataset.handle,
    title: button.dataset.title,
    url: button.dataset.url,
    image: button.dataset.image,
    price: Number(button.dataset.price || 0),
    priceLabel: button.dataset.priceLabel,
    productType: button.dataset.productType,
    available: button.dataset.available === 'true'
  });
  let toastTimer;
  const toast = message => {
    let el = document.querySelector('.stonehaus-saved-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'stonehaus-saved-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2200);
  };
  const sync = () => {
    const items = read();
    const handles = new Set(items.map(item => item.handle));
    $all('[data-saved-stone-button]').forEach(button => {
      const saved = handles.has(button.dataset.handle);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', `${saved ? 'Remove' : 'Save'} ${button.dataset.title}`);
      const label = button.querySelector('.stonehaus-save-button__label');
      if (label) label.textContent = saved ? 'Saved stone' : 'Save stone';
    });
    $all('[data-saved-stones-count]').forEach(counter => {
      counter.textContent = items.length;
      counter.hidden = items.length === 0;
    });
  };
  const toggle = button => {
    const product = productFromButton(button);
    const items = read();
    const index = items.findIndex(item => item.handle === product.handle);
    if (index >= 0) {
      items.splice(index, 1);
      toast(`${product.title} removed`);
    } else {
      items.unshift(product);
      toast(`${product.title} saved`);
    }
    write(items);
  };
  const decodeShared = () => {
    const params = new URLSearchParams(location.search);
    const value = params.get('saved');
    if (!value) return;
    try {
      const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
      const imported = JSON.parse(decodeURIComponent(escape(atob(base64))));
      if (Array.isArray(imported)) {
        const current = read();
        imported.reverse().forEach(item => {
          if (item && item.handle && !current.some(saved => saved.handle === item.handle)) current.unshift(item);
        });
        write(current);
        toast('Shared shortlist added');
      }
      params.delete('saved');
      history.replaceState({}, '', `${location.pathname}${params.toString() ? `?${params}` : ''}${location.hash}`);
    } catch (_) { toast('This shared shortlist could not be opened'); }
  };
  const quoteSummary = items => items.map((item, index) => {
    const input = document.querySelector(`[data-metres-for="${CSS.escape(item.handle)}"]`);
    const metres = input && input.value ? ` — ${input.value} m²` : '';
    return `${index + 1}. ${item.title}${metres}\n${location.origin}${item.url}`;
  }).join('\n\n');
  const updateQuote = items => {
    const field = document.getElementById('SavedStonesQuoteBody');
    if (field) field.value = `Project shortlist:\n\n${quoteSummary(items)}`;
  };
  const renderPage = () => {
    const grid = document.getElementById('SavedStonesGrid');
    if (!grid) return;
    const items = read();
    const empty = document.getElementById('SavedStonesEmpty');
    const content = document.getElementById('SavedStonesContent');
    if (empty) empty.hidden = items.length > 0;
    if (content) content.hidden = items.length === 0;
    const count = document.getElementById('SavedStonesPageCount');
    if (count) count.textContent = `${items.length} ${items.length === 1 ? 'stone' : 'stones'}`;
    grid.innerHTML = items.map(item => {
      const canSample = /stone cladding/i.test(item.productType || '');
      return `<article class="stonehaus-saved-card" data-saved-card="${esc(item.handle)}">
        <a class="stonehaus-saved-card__image" href="${esc(item.url)}">${item.image ? `<img src="${esc(item.image)}" alt="${esc(item.title)}" loading="lazy">` : ''}</a>
        <div class="stonehaus-saved-card__body">
          <h2 class="stonehaus-saved-card__title"><a href="${esc(item.url)}">${esc(item.title)}</a></h2>
          <p class="stonehaus-saved-card__price">From ${esc(item.priceLabel)}${/cladding/i.test(item.productType || '') ? ' per m²' : ''}</p>
          <div class="stonehaus-saved-card__fields">
            ${canSample ? `<label><input type="checkbox" data-sample-stone value="${esc(item.handle)}"> Include in sample pack</label>` : ''}
            <label class="stonehaus-saved-card__metres">Quote quantity <input type="number" min="0" step="0.5" inputmode="decimal" placeholder="m²" data-metres-for="${esc(item.handle)}"></label>
          </div>
          <button type="button" class="stonehaus-saved-card__remove" data-remove-saved="${esc(item.handle)}">Remove</button>
        </div>
      </article>`;
    }).join('');
    updateQuote(items);
  };
  const share = async () => {
    const items = read();
    if (!items.length) return toast('Save at least one stone first');
    const encoded = btoa(unescape(encodeURIComponent(JSON.stringify(items)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
    const url = `${location.origin}/pages/saved-stones?saved=${encoded}`;
    try {
      if (navigator.share) await navigator.share({ title: 'Stone Haus project shortlist', url });
      else { await navigator.clipboard.writeText(url); toast('Share link copied'); }
    } catch (error) { if (error.name !== 'AbortError') toast('Could not share this shortlist'); }
  };
  const orderSamples = async button => {
    const selected = $all('[data-sample-stone]:checked');
    if (!selected.length) return toast('Select up to three cladding samples');
    if (selected.length > 3) return toast('You can select a maximum of three samples');
    const items = read();
    const properties = {};
    selected.forEach((checkbox, index) => {
      const item = items.find(saved => saved.handle === checkbox.value);
      if (item) properties[`Sample ${index + 1}`] = item.title;
    });
    button.disabled = true;
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: SAMPLE_VARIANT_ID, quantity: 1, properties }] })
      });
      if (!response.ok) throw new Error('Sample pack could not be added');
      location.href = '/cart';
    } catch (_) {
      button.disabled = false;
      location.href = '/pages/order-cladding-samples';
    }
  };
  document.addEventListener('click', event => {
    const saveButton = event.target.closest('[data-saved-stone-button]');
    if (saveButton) { event.preventDefault(); event.stopPropagation(); return toggle(saveButton); }
    const removeButton = event.target.closest('[data-remove-saved]');
    if (removeButton) {
      const items = read().filter(item => item.handle !== removeButton.dataset.removeSaved);
      write(items); toast('Stone removed'); return;
    }
    if (event.target.closest('[data-share-saved]')) return share();
    const sampleButton = event.target.closest('[data-order-samples]');
    if (sampleButton) return orderSamples(sampleButton);
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-sample-stone]') && $all('[data-sample-stone]:checked').length > 3) {
      event.target.checked = false; toast('Choose up to three samples');
    }
    if (event.target.matches('[data-metres-for]')) updateQuote(read());
  });
  document.addEventListener('input', event => {
    if (event.target.matches('[data-metres-for]')) updateQuote(read());
  });
  document.addEventListener('submit', event => {
    if (event.target.matches('#SavedStonesQuoteForm')) updateQuote(read());
  });
  document.addEventListener('stonehaus:saved-stones:change', () => { sync(); renderPage(); });
  document.addEventListener('DOMContentLoaded', () => { decodeShared(); sync(); renderPage(); });
})();
